
import { OptionsClass } from '@/domain/entities/MainApp';
import { Options, Vue, prop } from 'vue-class-component'
import CheckBox from 'primevue/checkbox';
import { PropType } from "vue";
import debounce from "lodash/debounce";

class Props {
  placeholder = prop<string>({
    default: "Cari atau pilih"
  });
  modelValue = prop<string[]>({
    default: () => []
  });
  searchPlaceholder = prop<string>({
    default: "Search"
  });
  withSearch = prop<boolean>({
    default: false
  });
  isLoading = prop<boolean>({
    default: false
  });
  isWithChooseAll = prop<boolean>({
    default: false
  });
  isDisabled = prop<boolean>({
    default: false
  });
  filteredOptions = prop<OptionsClass[]>({
    default: () => []
  });
  options = prop<OptionsClass[]>({
    default: () => []
  });
  disabled = prop<boolean>({
    default: false
  });
  onOpenSelect = prop<Function>({
    default: Function as PropType<() => void>,
    type: Function
  });
  onFilter = prop<Function>({
    default: Function as PropType<() => void>,
    type: Function
  });
  timeout = prop<number>({
    default: 500
  });
  virtualAll = prop<boolean>({
    default: false
  });
  isAllSelected = prop<boolean>({
    default: false
  });
  maxSelect = prop<number>({
    default: 3
  });
}

@Options({
  components: {
    CheckBox
  },
  emits: ['onFilter']
})
class DropdownMultiSelect extends Vue.with(Props) {
  isDropdownVisible = false
  keyword = ''

  get filteredTempValue() {
    return this.tempValue.slice(0, this.maxSelect);
  }

  get isMax() {
    return this.tempValue.length > this.maxSelect;
  }

  get isSelectedAll(): boolean {
    return this.options.length > 0 && this.tempValue.length === this.options.length;
  }
  
  get tempValue() {
    return this.modelValue;
  }
  
  set tempValue(values: string[]) {
    this.$emit("update:modelValue", values);
  }

  get isVirtualAllActive(): boolean {
    return this.virtualAll && this.isAllSelected;
  }

  onSelectOption(value: string): void {
    if (this.virtualAll && this.isAllSelected) {
      this.$emit("update:isAllSelected", false);
    }
    if (this.tempValue.includes(value)) {
      this.tempValue = this.tempValue.filter(item => item !== value)
    } else {
      this.tempValue = [...this.tempValue, value];
    }
  }

  onSelectAll(): void {
    if (this.virtualAll) {
      this.tempValue = [];
      const nextValue = !this.isAllSelected;
      this.$emit("update:isAllSelected", nextValue);
      this.isDropdownVisible = false;
      return;
    }
    if (this.isSelectedAll) {
      this.tempValue = [];
    } else {
      this.tempValue = this.options.map((option) => option.value);
    }
  }

  onRemoveItem(value: string): void {
    if (this.disabled) return;
    this.tempValue = this.tempValue.filter(item => item !== value)
  }

  isChecked(value: string): boolean {
    return this.tempValue.includes(value)
  }

  onFilterOptions = debounce((event
  ) => {
    this.keyword = event.target.value
    this.onFilter(this.keyword);
  }, this.timeout)

  onClickField(e: any): void {
    if (this.disabled) return;
    this.isDropdownVisible = !this.isDropdownVisible;
    if (this.isDropdownVisible) {
      this.onOpenSelect();
    }
  }

  onClickOutside(): void {
    this.keyword = ''
    this.isDropdownVisible = false
  }

  getValueLabel(value = "") {
    return this.options.find(o => o.value === value)?.label || value;
  }

}
export default DropdownMultiSelect
